module.exports = __webpack_public_path__ + "img/company.08ff16b2.svg";